import { LinkOpenTypes, SAMSKIP_SUBSYS } from "@assets/constants";
import { MenuItem } from "@assets/types";

const addExtraMenuItems = (menu: MenuItem[]): MenuItem[] => {
  // We need a deep copy of the array to make sure we are not changing the initial array
  // Note: this wouldn't be needed if the backend would handle the menu items instead of the frontend inserting random menus

  const newMenu = JSON.parse(JSON.stringify(menu));

  newMenu.unshift({
    ExternalLink: 0,
    MenuID: 201,
    MenuLevel: 1,
    MenuName: " ",
    MenuParent: 200,
    OrderID: 0,
    Site: "/",
    SystemID: SAMSKIP_SUBSYS,
    Tooltip: "",
    Translate: "MENU_MYPAGE",
    children: [],
  });

  newMenu.push({
    ExternalLink: 0,
    MenuID: 208,
    MenuLevel: 1,
    MenuName: "Settings",
    MenuParent: 200,
    OrderID: 6,
    Site: "",
    SystemID: SAMSKIP_SUBSYS,
    Tooltip: "",
    Translate: "",
    children: [],
  });

  return newMenu;
};

export const setupMenu = (menuItems: MenuItem[]) => {
  const menu = addExtraMenuItems(menuItems);
  const menuTree: MenuItem[] = [];

  const dataMap = menu.reduce((map, node) => {
    map[node.MenuID] = node;
    return map;
  }, {});

  for (const node of menu) {
    // add to parent
    const parent = node.MenuParent ? dataMap[node.MenuParent] : null;
    if (parent) {
      // create child array if it doesn't exist
      const nodes = parent.children || (parent.children = []);
      // add node to child array
      if (node.OrderID) {
        nodes.splice(node.OrderID, 0, node);
      } else {
        nodes.push(node);
      }
    } else {
      // parent is null or missing
      menuTree.push(node);
    }
  }
  return menuTree[0].children;
};

export const constructLink = (item: MenuItem) => {
  // If ExternalLink === 0, we are working with a MainServiceWeb menu item
  if (item.ExternalLink === LinkOpenTypes.mainServiceWeb) {
    // This is a really ugly hardcoded hack until the navigation will be fixed
    // In the Service Web some menu items had invalid links because they had double /,
    // the solution was to remove them in the database...so this is why we need this hack
    return item.Site.charAt(0) !== "/"
      ? `${process.env.MainServiceWeb}/${item.Site}`
      : `${process.env.MainServiceWeb}${item.Site}`;
  }

  // If the Site has http/https in it, we redirect to that one
  if (item.Site.startsWith("https://") || item.Site.startsWith("http://")) {
    return item.Site;
  }
  // If the site has aspx, then open the old web
  if (item.Site.endsWith(".aspx")) {
    const popupAppend = `${item.Site.indexOf("?") === -1 ? "?" : "&"}Popup=1`;
    return `${process.env.OldServiceWeb}/${item.Site}${popupAppend}`;
  } else {
    return `/${item.Site}`;
  }
};

export const constructMainServiceWebLink = (link: string) => {
  return `${process.env.MainServiceWeb}${link}`;
};
